var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-clock"},[(_vm.$scopedSlots.time)?_vm._t("time",null,null,{h: _vm.h, m: _vm.m, s: _vm.s}):_c('span',[_vm._v(_vm._s(_vm.showTime))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }